import React from "react"
import PageLayout from "../display/page"
import Prose from "@ui-kit/atoms/prose"
import tw, { styled } from "twin.macro"

const Paragraph__Prose = ({ body, wysiwygFiles, wysiwygImages }) => {
  return body ? (
    <Wrapper className="content-slice content-slice--prose">
      <PageLayout className="promotion" style={{ marginTop: 0 }}>
        <Prose
          className="prose w-full"
          html={body.raw}
          wysiwygFiles={wysiwygFiles}
          wysiwygImages={wysiwygImages}
        />
      </PageLayout>
    </Wrapper>
  ) : (
    <></>
  )
}
export default Paragraph__Prose

const Wrapper = styled.div`
  ${tw`mt-0`}

  *:where(header, .promotion--two-col) + & {
    ${tw`[marginTop:var(--promotion-space, 5.5vmin)]`}
  }

  h1 + & {
    ${tw`[marginTop:var(--promotion-space, 5.5vmin)]`}
  }
`
